import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { withMountListener } from '@beef/react';
import { connect } from 'react-redux';
import { compose } from '@beef/redux';
import { ActionCreator } from "../../../store/actions";
import { NotificationsMapper } from "./NotificationsMapper";
import { selectNotifications } from "../../../store/selectors";
import { NotificationItem } from "./NotificationItem";
export var _Notifications = function _Notifications(_ref) {
  var notifications = _ref.notifications,
    isSideMenuOpen = _ref.isSideMenuOpen,
    onClose = _ref.onClose;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    topItemHeight = _useState2[0],
    setTopItemHeight = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isExpanded = _useState4[0],
    setIsExpanded = _useState4[1];
  var isSingleNotification = (notifications === null || notifications === void 0 ? void 0 : notifications.length) < 2;
  useEffect(function () {
    setIsExpanded(false);
  }, [isSideMenuOpen]);
  return /*#__PURE__*/React.createElement(NotificationsMapper, {
    expanded: isExpanded || isSingleNotification,
    notifications: notifications,
    topItemHeight: topItemHeight,
    "data-t-id": "Container-Notifications"
  }, function (_ref2) {
    var notification = _ref2.notification,
      index = _ref2.index;
    return /*#__PURE__*/React.createElement(NotificationItem, {
      height: topItemHeight,
      isExpanded: isExpanded || isSingleNotification,
      isTop: index === 0,
      notification: notification,
      onClick: function onClick() {
        return setIsExpanded(true);
      },
      onClose: onClose,
      setHeight: setTopItemHeight
    });
  });
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    notifications: selectNotifications(state)
  };
};
var mapDispatchToProps = {
  onMount: ActionCreator.fetchNotifications
};
export var Notifications = compose(connect(mapStateToProps, mapDispatchToProps), withMountListener)(_Notifications);